import { createSelector } from '@reduxjs/toolkit';

import { selectVideoViews } from 'selectors/videoPlayer';

const selectViewerInsights = state => state.viewerInsights;

export const selectIsActive = createSelector(
  selectViewerInsights,
  viewerInsights => viewerInsights.isActive
);
export const selectViewers = createSelector(
  selectViewerInsights,
  viewerInsights => viewerInsights.viewers
);
export const selectActiveViewer = createSelector(
  selectViewerInsights,
  viewerInsights => viewerInsights.selectedView || null
);
export const selectViewersForEngagementInsights = createSelector(
  selectViewers,
  (rawViewers = []) => {
    return rawViewers.map(rawViewer => ({
      commentCount: (rawViewer.events || []).filter(
        evt => evt.type === 'comment' || evt.type === 'reply'
      ).length,
      reactionCount: (rawViewer.events || []).filter(
        evt => evt.type === 'reaction'
      ).length,
      ...rawViewer,
    }));
  }
);

export const selectViewersForViewerInsights = createSelector(
  selectVideoViews,
  (views = {}) => {
    const namedViews = views?.named || [];
    const distinctViews = views?.distinct || 0;
    const viewers = namedViews.map(namedView => ({
      user: { name: `${namedView.firstName} ${namedView.lastName}` },
    }));

    const anonymousViews = distinctViews - viewers.length;

    for (let i = 0; i < anonymousViews; i++) {
      viewers.push({ user: {} });
    }

    return viewers;
  }
);
